import {
	DomainsSettings,
	DomainsSettingsSkeleton,
} from "@commerce/domains/DomainsSettings";
import { domainsQuery } from "@commerce/domains/meta";
import { config } from "@repo/config";
import { AdminOnlyNotice } from "@saas/settings/components/SettingsLayout";
import { AsyncBoundary } from "@shared/components/AsyncBoundary";
import { dehydrateForLoader, getServerQueryClient } from "@shared/lib/server";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/_saas/app/_org/$organizationSlug/settings/domains",
)({
	loader: async ({ context }) => {
		const queryClient = getServerQueryClient();
		if (context.isOrganizationAdmin) {
			await queryClient.ensureQueryData(
				domainsQuery(context.organization.id),
			);
		}
		return {
			organizationId: context.organization.id,
			dehydratedState: dehydrateForLoader(queryClient),
		};
	},
	head: () => ({ meta: [{ title: `Domains - ${config.appName}` }] }),
	component: DomainsPage,
});

function DomainsPage() {
	const { isOrganizationAdmin } = Route.useRouteContext();
	const { organizationId, dehydratedState } = Route.useLoaderData();

	if (!isOrganizationAdmin) {
		return <AdminOnlyNotice what="domains" />;
	}

	return (
		<AsyncBoundary
			fallback={<DomainsSettingsSkeleton />}
			dehydratedState={dehydratedState}
			errorFallback="inline"
		>
			<DomainsSettings organizationId={organizationId} />
		</AsyncBoundary>
	);
}
